module.exports = __webpack_public_path__ + "static/media/caixa-selecao-icon.50fe6eb8.svg";